<template>
  <div>
    <transition name="shake" mode="out-in">
      <img
        v-if="visible"
        src="@/assets/images/msg.png"
        width="35"
        height="35"
        class="rotate"
      />
    </transition>
  </div>
</template>

<script>
export default {
  name: "SafeWEBMyIconComponent",

  data() {
    return {
      visible: true,
    };
  },

  mounted() {
    this.startShaking();
  },

  beforeUnmount() {
    this.stopShaking();
  },

  methods: {
    startShaking() {
      this.timer = setInterval(() => {
        this.visible = false;
        setTimeout(() => {
          this.visible = true;
        }, 500);
      }, 1500);
    },

    stopShaking() {
      clearInterval(this.timer);
    },
  },
};
</script>

<style lang="scss" scoped>
.rotate {
  display: block;
  animation: rotate 0.2s linear;
}

@keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }
  20% {
    transform: rotateZ(20deg);
  }
  40% {
    transform: rotateZ(0deg);
  }
  60% {
    transform: rotateZ(-20deg);
  }
  80% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(0deg);
  }
}

.shake-enter-active,
.shake-leave-active {
  animation-duration: 0.2s;
}

.shake-enter,
.shake-leave-to {
  transform: rotateZ(0deg);
}
</style>
